export const TEXTS = {
  LIST_SLIDER_TITLE: 'Способ оплаты',
};
